.studentCell {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

.avatar {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  /* Indigo is the student accent across the product; teal marks mentors. */
  background: var(--indigo-soft);
  color: var(--indigo);
  font-size: var(--text-xs);
  font-weight: var(--weight-semibold);
  border-radius: 50%;
  flex-shrink: 0;
}

.studentText {
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.35;
}

.verifyCell {
  display: flex;
  gap: var(--space-2);
}
